import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import UnitsTable from "../../components/Units/UnitsTable";

const UnitsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Project's Units" />
        
        {/* Units Table */}
        <UnitsTable />
      </MasterLayout>
    </>
  );
};

export default UnitsPage;
